// @ts-nocheck — verbatim port from xop-edge-staff. See src/crm/README.md.
import api from './api'

/** The agent's email confidence ladder (mirrors crm-api's
 * `CustomerContact::EMAIL_CONFIDENCES`). `verified`/`likely` are deliverable;
 * `guessed`/`unknown`/null are flagged so a campaign never blasts a risky
 * address by accident. */
export type EmailConfidence = 'unknown' | 'guessed' | 'likely' | 'verified'

// Customer Contact interfaces
export interface CustomerContact {
  id: number
  first_name?: string
  last_name?: string
  full_name: string
  display_name: string
  initials: string
  email?: string
  /** Trust signal for `email` — set on AI-generated prospects' contacts so the
   * email-campaign recipient picker can flag guessed-vs-verified. */
  email_confidence?: EmailConfidence | null
  email2?: string
  phone?: string
  phone2?: string
  mobile?: string
  primary_phone?: string
  company_name?: string
  job_title?: string
  website?: string
  address?: string
  city?: string
  state?: string
  country?: string
  postal_code?: string
  timezone?: string
  location?: string
  complete: boolean
  contactable: boolean
  has_coordinates: boolean
  created_at: string
  updated_at: string
}

export interface CustomerContactCreateData {
  first_name?: string
  last_name?: string
  email?: string
  email2?: string
  phone?: string
  phone2?: string
  mobile?: string
  company_name?: string
  job_title?: string
  website?: string
  address?: string
  city?: string
  state?: string
  country?: string
  postal_code?: string
  timezone?: string
}

export interface CustomerContactUpdateData extends Partial<CustomerContactCreateData> {}

export interface CustomerContactsResponse {
  contacts: CustomerContact[]
  message?: string
}

export interface CustomerContactResponse {
  contact: CustomerContact
  message?: string
}

// Customer Contacts API
export const customerContactsApi = {
  /**
   * Create a new customer contact
   */
  create: async (customerId: string, contactData: CustomerContactCreateData): Promise<CustomerContactResponse> => {
    const response = await api.post(`/customers/${customerId}/contacts`, { 
      customer_contact: contactData 
    })
    return {
      contact: response.data.data,
      message: response.data.message
    }
  },

  /**
   * Update an existing customer contact
   */
  update: async (customerId: string, contactId: string, contactData: CustomerContactUpdateData): Promise<CustomerContactResponse> => {
    const response = await api.put(`/customers/${customerId}/contacts/${contactId}`, { 
      customer_contact: contactData 
    })
    return {
      contact: response.data.data,
      message: response.data.message
    }
  },

  /**
   * Delete a customer contact
   */
  delete: async (customerId: string, contactId: string): Promise<{ message: string }> => {
    const response = await api.delete(`/customers/${customerId}/contacts/${contactId}`)
    return {
      message: response.data.message || 'Contact deleted successfully'
    }
  }
}
